import React, {useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import {useChangePassword} from '../application/useChangePassword';
import {isFailure, isSuccess} from '../../common/domain/RemoteData.model';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

const PasswordRules = styled.ul`
    list-style: none;
    padding-left: 1rem;
    font-size: 14px;
    color: #333;

    li {
        margin-bottom: 4px;
    }

    .valid {
        color: green;
    }

    .invalid {
        color: red;
    }
`;

export const ContainerForm = styled.div`
    padding: 1rem;

    h3 {
        text-align: center;
        font-weight: 400;
        font-size: 24px;
    }
`;

export const ContainerInput = styled.div`
    position: relative;
    margin-top: .5rem;
    color: #696969;

    span {
        display: block;
        margin-bottom: 4px;
    }

    input {
        border: 1px solid #E7E7E7;
        border-radius: 10px;
        width: 100%;
        height: 40px;
        padding: 0 3rem 0 1rem;
        outline: none;
    }

    .toggle-visibility {
        position: absolute;
        top: 34px;
        right: 10px;
        cursor: pointer;
    }
`;

export const DivBtn = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
`;

const getPasswordValidations = (password) => ({
    length: password.length >= 8,
    number: /\d/.test(password),
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
});

export const ChangePass = ({onPasswordChanged}) => {
    const {
        passwordUpdate,
        resetPasswordRemoteData,
        setOldPassword,
        setNewPassword,
        setRepeatPassword,
        updatePassword,
        isInvalid
    } = useChangePassword();

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);

    const passwordValidations = getPasswordValidations(passwordUpdate.newPassword);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await updatePassword();
    };

    useEffect(() => {
        if (isSuccess(resetPasswordRemoteData)) {
            toast.success('Contraseña actualizada!');
            onPasswordChanged();
        } else if (isFailure(resetPasswordRemoteData)) {
            toast.error(resetPasswordRemoteData.error);
        }
    }, [resetPasswordRemoteData]);

    return (
        <ContainerForm>
            <form autoComplete="off" onSubmit={handleSubmit}>
                {/* Old Password */}
                <ContainerInput>
                    <span>Contraseña anterior</span>
                    <input
                        autoComplete="off"
                        type={showOld ? 'text' : 'password'}
                        placeholder="Contraseña anterior"
                        required
                        value={passwordUpdate.oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                    />
                    <div className="toggle-visibility" onClick={() => setShowOld(!showOld)}>
                        {showOld ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                    </div>
                </ContainerInput>

                {/* New Password */}
                <ContainerInput>
                    <span>Nueva Contraseña</span>
                    <input
                        autoComplete="off"
                        type={showNew ? 'text' : 'password'}
                        placeholder="Nueva contraseña"
                        required
                        value={passwordUpdate.newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <div className="toggle-visibility" onClick={() => setShowNew(!showNew)}>
                        {showNew ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                    </div>

                    <PasswordRules>
                        <li className={passwordValidations.length ? 'valid' : 'invalid'}>➤ Mínimo 8 caracteres</li>
                        <li className={passwordValidations.number ? 'valid' : 'invalid'}>➤ Contiene al menos 1 número
                        </li>
                        <li className={passwordValidations.uppercase ? 'valid' : 'invalid'}>➤ Contiene al menos 1 letra
                            mayúscula
                        </li>
                        <li className={passwordValidations.lowercase ? 'valid' : 'invalid'}>➤ Contiene al menos 1 letra
                            minúscula
                        </li>
                    </PasswordRules>
                </ContainerInput>

                {/* Repeat Password */}
                <ContainerInput>
                    <span>Vuelva a escribir la contraseña</span>
                    <input
                        autoComplete="off"
                        type={showRepeat ? 'text' : 'password'}
                        placeholder="Contraseña"
                        required
                        value={passwordUpdate.repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    />
                    <div className="toggle-visibility" onClick={() => setShowRepeat(!showRepeat)}>
                        {showRepeat ? <VisibilityOffIcon/> : <VisibilityIcon/>}
                    </div>
                </ContainerInput>

                <DivBtn>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isInvalid(passwordUpdate)}
                    >
                        Actualizar contraseña
                    </button>
                </DivBtn>
            </form>
        </ContainerForm>
    );
};
